import { HttpParams } from '@angular/common/http';
import { ListMetadata } from '../../../models/list-metadata.model';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Campaign } from 'app/models/campaign2.model';
import { map, catchError, publishReplay, refCount } from 'rxjs/operators';
import { ActionType, AdvantageType, Campaign3DuplicateAction, CouponType, MessageInstanceRuleObjectTypeResponse, MessageType, PreferredCoupon } from '../models/campaign-3-info-base.model';
import { MessageInstanceObject, JsonSchema, CampaignSingleObjectResponse, MessageInstanceObjectTypes, MessageInstanceRuleTypes, DistributionListCluster, DistributionListDetails, BasketProductItem, ProductDepartment, ProductCategory, Campaign3Store, Campaign3Campaign, Campaign3MessageInstance, Touchpoint, Campaign3StatusMapping, Campaign3ActionStatus, ProductItemComplete, JsonSchemaFormPropertiesForm, CalculateFruitionDateResponse, CalculateFruitionDateRequest } from '../models/campaign-3.model';
import { HttpClientService } from 'app/services/httpClient/httpclient.service';
import { PhaseToolbarModel } from '../models/phases-toolbar.model';
import { BreadCrumbModel } from '../models/campaign-3-breadcrumb.model';
import { ClusterHeadNewList } from '../models/campaign-3-customer-target.model';
import { AreaGeo, Group, Insegna } from '../models/campaign-3-touchpoint.model';
import { CertificationTouchpointList } from '../models/campaign-3-validation.model';
import { LoyaltyReportPayload } from 'app/models/loyalty-report.model';
import { of } from 'rxjs/observable/of';

@Injectable()
export class Campaign3Service {
  baseUrl = 'koncentro-promo/campaign';
  campaignUrl = 'koncentro-promo';
  commonUrl = 'koncentro-common';
  loyaltyUrl = 'koncentro-loyalty';
  paramKeyCampaignType = 'DEFAULT.CAMPAIGN_TYPE';
  paramKeyBarcodeType = 'COUPON_DEFAULT_BARCODE_TYPE';
  cachedCampaignFields: Observable<Campaign>;
  generateCouponUrl = 'koncentro-promo/campaign/message-instance/generateCoupon';
  priorityOnline: any[] = [];
  couponId: string;
  customerId: string;
  clientCustomerId: string;
  distributionListId: string;

  //info conosciute a priori
  formNames = {
    infoBase: "form.infobase",
    tipoAzioni: "form.tipoazioni",
    pianificazione: "form.pianificazione",
    emissione: "form.emissione",
    fruizione: "form.fruizione",
    customerTarget: "form.customertarget",
    targetArticoli: "form.targetarticoli",
    touchpoint: "form.touchpoint"
  }


  //info conosciute a priori
  infoBaseFieldsName = {
    coupon_type: "tipo_coupon",
    advantage_type: "advantage_type",
    valore_coupon: "valore_coupon",
    name: "name",
    public_description: "description",
    int_code: "code",
    int_note: "notes"
  }


  //info conosciute a priori
  tipoAzioniFieldsName = {
    clienti_destinati_promo: "clienti_destinati_promo",
    tipo_attuazione_promo: "tipo_attuazione_promo"
  }


  //info conosciute a priori
  pianificazioneFieldsName = {
    come_campagna: "come_campagna",
    come_emissione: "come_emissione",
    variabili: "variabili",
    data_inizio_emissione: "data_inizio_emissione",
    data_fine_emissione: "data_fine_emissione",
    data_inizio_fruizione: "data_inizio_fruizione",
    data_fine_fruizione: "data_fine_fruizione",
    modalita_inizio_fruizione: "modalita_inizio_fruizione",
    modalita_fine_fruizione: "modalita_fine_fruizione",
    offset_inizio_fruizione: "offset_inizio_fruizione",
    offset_fine_fruizione: "offset_fine_fruizione",
    giorno_settimana_inizio: "giorno_settimana_inizio",
    giorno_settimana_fine: "giorno_settimana_fine",
    data_inizio_fruizione_fissa: "data_inizio_fruizione_fissa",
    data_fine_fruizione_fissa: "data_fine_fruizione_fissa"
  }
  //modifiche KS-7228 aggiunti nuovi campi e eliminata gestione-acc
  emissioneFieldsName = {
    tipo_soglia_emissione: "tipo_soglia_emissione",
    soglia_emissione_coupon: "soglia_emissione_coupon",
    soglia_riemissione_coupon: "soglia_riemissione_coupon",
    numero_massimo_emissioni_clienti: "numero_massimo_emissioni_clienti",
    accumulatore_operazione: "accumulatore_operazione",
    accumulatore_valore: "accumulatore_valore",
    articolo_coupon: "articolo_coupon",
    barcode_coupon: "barcode_coupon",
    solo_barcode: "solo_barcode",
    articolo_coupon_attivatore: "articolo_coupon_attivatore",
    barcode_coupon_attivatore: "barcode_coupon_attivatore",
    solo_barcode_attivatore: "solo_barcode_attivatore",
    num_max_emissioni_totali: "num_max_emissioni_totali",
    num_max_transazioni_emittenti_clienti: "num_max_transazioni_emittenti_clienti",
    num_max_emissioni_cliente: "num_max_emissioni_cliente",
    coupon_ripetibile: "coupon_ripetibile",
    switch_barcode_attivatore: "switch_barcode_attivatore",
    switch_limiti_emissione: "switch_limiti_emissione",
    switch_gestione_accumulatori: "switch_gestione_accumulatori",
    accumulatori_operazione: "accumulatori_operazione",
    accumulatori_regole_avanzate: "accumulatori_regole_avanzate",
    accumulatore_regole_operatore: "accumulatore_regole_operatore",
    accumulatore_regole_valore: "accumulatore_regole_valore"
  }



  emissioneFieldsNameTemp = {
    switch_limiti_emissione: 'switch_limiti_emissione',
    switch_barcode_attivatore: 'switch_barcode_attivatore',
    gestione_accumulatori: 'gestione_accumulatori',
    tipo_soglia_emissione: 'tipo_soglia_emissione',
    soglia_emissione_coupon: 'soglia_emissione_coupon',
    numero_massimo_emissioni_clienti: 'numero_massimo_emissioni_clienti',
    accumulatore_operazione: 'accumulatore_operazione',
    accumulatore_valore: 'accumulatore_valore',
    articolo_coupon: 'articolo_coupon',
    barcode_coupon: 'barcode_coupon',
    solo_barcode: 'solo_barcode',
    articolo_coupon_attivatore: 'articolo_coupon_attivatore',
    barcode_coupon_attivatore: 'barcode_coupon_attivatore',
    solo_barcode_attivatore: 'solo_barcode_attivatore',
    num_max_emissioni_totali: 'num_max_emissioni_totali',
    num_max_transazioni_emittenti_clienti: 'num_max_transazioni_emittenti_clienti',
    num_max_emissioni_cliente: 'num_max_emissioni_cliente',
    switch_gestione_accumulatori: "switch_gestione_accumulatori",
    accumulatori_operazione: "accumulatori_operazione",
    accumulatori_regole_avanzate: "accumulatori_regole_avanzate",
    accumulatore_regole_operatore: "accumulatore_regole_operatore",
    accumulatore_regole_valore: "accumulatore_regole_valore"
  }



  fruizioneFieldsName = {
    tipo_soglia_fruizione: "tipo_soglia_fruizione",
    soglia_fruizione: "soglia_fruizione",
    accumulatore_operazione: "accumulatore_operazione",
    accumulatore_valore: "accumulatore_valore",
    numero_utilizzi: "numero_utilizzi",
    modalita_utilizzo: "modalita_utilizzo",
    num_max_fruizioni_totali_cliente: "num_max_fruizioni_totali_cliente",
    num_max_transazioni_cliente: "num_max_transazioni_cliente",
    num_max_fruizioni_cliente_transazione: "num_max_fruizioni_cliente_transazione",
    modo_calcolo_soglia: "modo_calcolo_soglia",
    switch_gestione_accumulatori: "switch_gestione_accumulatori",
    switch_limiti_fruizione: "switch_limiti_fruizione",
    accumulatori_operazione: "accumulatori_operazione",
    accumulatori_regole_avanzate: "accumulatori_regole_avanzate",
    accumulatore_regole_operatore: "accumulatore_regole_operatore",
    accumulatore_regole_valore: "accumulatore_regole_valore"
  }


  //info conosciute a priori
  customerTargetFieldsName = {
    switch_carta_necessaria: "switch_carta_necessaria",
    switch_come_emissione: "switch_come_emissione",
    lista_distribuzione_emissione: "lista_distribuzione_emissione",
    lista_distribuzione_fruizione: "lista_distribuzione_fruizione",
    tipo_controllo: "tipo_controllo"
  }


  //info conosciute a priori
  targetArticoliFieldsName = {
    tipo_entita_emissione: "tipo_entita_emissione",
    tipo_entita_fruizione: "tipo_entita_fruizione"
  }


  //info conosciute a priori
  touchpointFieldsName = {
    wizard: "wizard",
    switch_offline_emissione: "switch_offline_emissione",
    switch_online_emissione: "switch_online_emissione",
    switch_offline_fruizione: "switch_offline_fruizione",
    switch_online_fruizione: "switch_online_fruizione",
    switch_offline_come_emissione: "switch_offline_come_emissione",
    switch_online_come_emissione: "switch_online_come_emissione"
  }


  ui_modes = {
    CREATE: "CREATE",
    EDIT: "EDIT"
  }

  coupon_modes = {
    CREATE: "CREATE",
    EDIT: "EDIT"
  }


  schema_modes = {
    CREATE: "create",
    EDIT_PREVIEW: "edit_prev",
    EDIT_DEFINITIVE: "edit_def"
  }

  acmTypesEmissionFruition = {
    EMISSION: "emission",
    FRUITION: "fruition"
  }

  ruleScopesEmissionFruition = {
    EMISSION: "emission",
    FRUITION: "fruition"
  }

  ruleIncludeExclude = {
    INCLUDE: "include",
    EXCLUDE: "exclude"
  }

  touchpointAcceptDefault = {
    YES: "Yes",
    NO: "No"
  }

  touchpointCertifier = {
    YES: "Yes",
    NO: "No"
  }

  touchpointCertified = {
    YES: "Yes",
    NO: "No"
  }

  actionTypes = {
    MESSAGE: {
      shortCode: "M",
      code: "MSG",
      assignmentEntity: "message"
    },
    COUPON: {
      shortCode: "C",
      code: "CPN",
      assignmentEntity: "coupon"
    }
  }

  clientiDestinatiPromo = {
    LOY: "LOY",
    NOLOY: "NOLOY",
    ALL: "ALL",
  }

  tipoAttuazionePromo = {
    PROMO: "PROMO",
    NOPROMO: "NOPROMO"
  }

  tipoAzioneStaticoDinamico = {
    STATIC: {
      shortCode: "S",
      code: "STATIC",
      description: "Statico"
    },
    DYNAMIC: {
      shortCode: "D",
      code: "DYNAMIC",
      description: "Dinamico"
    }
  }

  couponType = {
    RIPETIBILE: "R",
    SINGOLO: "S"
  }

  modoSogliaFruizione = {
    INCREMENTALE: "IN",
    ASSOLUTO: "AS"
  }

  tipoUtilizzoCoupon = {
    SINGOLO: "S",
    MULTIUSO: "M"
  }

  tipoControllo = {
    QUALUNQUE_CARTA_VALIDA: "G",
    QUALUNQUE_CARTA_VALIDA_CLIENTE: "C",
    CARTA_ASSOCIATA_COUPON: "S"
  }

  constructor(
    private http: HttpClientService
  ) { }

  /**
   * Restituisce la lista delle Campagne
   */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '?' + params.toString());
  }


  /**
   * Restituisce le liste campagne
   */
  getCampaignList() {
    return this.http.get(`${this.baseUrl}`);
  }

  /**
   * Restituisce le azioni di una campagna, tramite il suo id
   * @param campaignId id della campagna
   */
  getCampaignAction(campaignId: number) {
    return this.http.get(this.baseUrl + '/campaign_action' + '/' + campaignId);
  }

  /**
   * Restituisce la lista delle azione di una campagne, tramite nome delle azioni
   */
  filterCampaignAction(
    campaignId,
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/campaign_action' + '/' + campaignId + '?' + params.toString());
  }

  /**
 * Restituisce un azione di una campagna, tramite il suo id
 * @param campaignId id della campagna
 * @param campaignActionId id dell'azione
 */
  getCampaignActionById(campaignId: number, campaignActionId: number) {
    return this.http.get(this.baseUrl + `/campaign_action/${campaignId}?id=${campaignActionId}`);
  }

  /**
    * Tramite metodo GET carico i campi del dto di Campaign2 in un Observable
    * @returns il dto campaign2
    */
  getCampaignFields() {
    if (!this.cachedCampaignFields) {
      this.cachedCampaignFields = this.http.get(`${this.campaignUrl}/schema/CampaignDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedCampaignFields;
  }

  /**
   * Restituisce la lista dei tipi di budget
   * @returns lista dei tipi di budget
   */
  getBudgetType() {
    return this.http.get(this.baseUrl + '/budget-type');
  }


  /**
   * Crea una Nuova Campagna
   * @param campaign l'oggetto di tipo Campagna da creare
   * @returns  ritorna l'oggetto di tipo CDampagna creato
   */
  createCampaign(campaign: Campaign) {
    return this.http.post(this.baseUrl, campaign);
  }

  /**
   * Aggiorna una campagna già esistente
   * @param campaign l'oggetto di tipo Campagna modificato
   * @param id l'id della Campagna da modificare
   * @returns ritorna la Campagna modificata
   */
  updateCampaign(campaign: Campaign, id: number) {
    return this.http.put(this.baseUrl + `/${id}`, campaign);
  }

  /**
   * Ritorna l'id del tipo campagna dalla param
   */
  getParamCampaignTypeId() {
    return this.http.get(this.loyaltyUrl + '/params/getParam/' + this.paramKeyCampaignType);
  }

  /**
   * Ritorna il barcode type pid dalla param
   */
  getParamBarcodeTypePid() {
    return this.http.get(this.loyaltyUrl + '/params/getParam/' + this.paramKeyBarcodeType);
  }

  /**
   * Restituisce i tipi di coupon selezionabili
   */
  getCampaignMessage(message: string) {
    return this.http.get(`${this.baseUrl}/message?assignement_entity=${message}`);
  }

  /**
   * Ritorna il template di una determinata action
   * @param actionId l'id dell'action di cui si vuole il template
   * @returns ritorna un template
   */
  getActionTemplate(actionId: number) {
    return this.http.get(this.baseUrl + `/action_type/template/${actionId}`);
  }

  /**
   * Restituisce i dati per il form di emissione del coupon
   */
  getCouponEmissionData(campaignId: string, actionId: string) {
    return this.http.get(`${this.baseUrl}/campaign_action/${campaignId}?id=${actionId}`);
  }

  /**
   * Restituisce la lista dei touchpoints selezionabili
   * per la distribuzione del coupon
   */
  getTouchPoints(couponScope: string, couponActionType: string) {
    return this.http.get(`koncentro-promo/touch-point?flg_coupon_scope=${couponScope}&flg_coupon_action=${couponActionType}`);
  }

  /**
   * Restituisce i touchpoint e le relative priorità
   */
  getChannelPriorities(actionId: string, type: string) {
    return this.http.get(`${this.baseUrl}/campaign_action/ochannel?campaign_action_id=${actionId}&type=${type}`);
  }

  getChannelByCampaignAction(actionId: string) {
    return this.http.get(`${this.baseUrl}/campaign_action/ochannel?campaign_action_id=${actionId}`);
  }

  getMessageInstance(messageInstanceId: number) {
    return this.http.get(`${this.baseUrl}/message-instance?id=${messageInstanceId}`);
  }

  /**
   * Restituisce la lista dei filtri Area Geografica per i Negozi
   */
  getAreaGeo() {
    return this.http.get('/koncentro-common/store/getAreaGeo');
  }

  /**
   * Restituisce la lista dei filtri Insegne per i Negozi
   */
  getInsegna() {
    return this.http.get('/koncentro-common/store/getInsegna');
  }

  /**
   * Restituisce la lista dei filtri Gruppi per i Negozi
   */
  listGroups() {
    return this.http.get('/koncentro-common/store-group');
  }

  /**
   * Restituisce la lista dei negozi associabili alla Campagna, filtrandoli a seconda dei parametri inviati.
   * Se nel parametro "codici" di "filters" sono presenti store_code, restituisce i negozi già associati alla Campagna
   * @param filters
   */
  getStoresFromFilters(filters: object) {
    return this.http.post('/koncentro-common/store/v2/stores_from_campaigns', filters);
  }
  /**
   * Restituisce la lista dei negozi di un Gruppo
   * @param groupdId
  */
  listStoresInGroup(groupdId) {
    return this.http.get(`/koncentro-common/store-group/${groupdId}/store`);
  }

  /**
   * Restituisce la lista dei Gruppi di Negozi
   */
  listGroupsWithStores() {
    return this.http.get('/koncentro-common/store-group/stores');
  }

  /**
   * Restituisce le liste clienti
   */
  getCustomerLists() {
    return this.http.get(`${this.baseUrl}/distribution_list/list`);
  }

  /**
   * Ritorna una distribution list specifica per ID
   * Usato quando la lista non è presente nel caricamento iniziale (es. eliminata)
   * @param distributionListId id della distribution list
   */
  getDistributionListById(distributionListId: number) {
    return this.http.get(`${this.baseUrl}/distribution_list/getDistributionList?id=${distributionListId}`);
  }

  saveEmissionDates(data: any) {
    return this.http.post(`${this.baseUrl}/campaign_action`, data);
  }

  updateEmissionDates(data: any) {
    return this.http.put(`${this.baseUrl}/campaign_action`, data);
  }

  saveCouponEmissionData(data: any) {
    return this.http.post(`${this.baseUrl}/message_action_complete`, data);
  }

  updateCouponEmissionData(messageInstanceId: number, data: any) {
    return this.http.put(`${this.baseUrl}/message_action_complete/${messageInstanceId}`, data);
  }
  getMessageInstanceData(messageInstanceId: string) {
    return this.http.get(`${this.baseUrl}/message-instance?id=${messageInstanceId}`);
  }

  getDtoSchemas(schema: string) {
    return this.http.get('koncentro-promo/schema/' + schema + 'Dto');
  }

  /**
   * Restituisce i campi del form di configurazione dei parametri del coupon
   */
  getCouponParamSetupFields(messageId: number, actionTypeCode: string) {
    return this.http.get(`${this.baseUrl}/template_assignement/list?assigned_to_id=${messageId}&assignement_entity=${actionTypeCode}`);
  }

  getPromoTypes(messageTypeId: number) {
    return this.http.get(`${this.baseUrl}/promo-type?message_type_id=${messageTypeId}`);
  }

  getConstraints(type: string) {
    return this.http.get(`${this.baseUrl}/campaign-constraint/list?constraint_type=${type}`);
  }

  getConstraintsData(messageInstanceId: string) {
    return this.http.get(`${this.baseUrl}/message-instance/constraint/${messageInstanceId}/list`);
  }

  getBasketDescriptionByMessageId(messageId: number) {
    return this.http.get(`${this.baseUrl}/message/${messageId}/basket`);
  }

  getBasketDescriptionByBasketId(basketId: number) {
    return this.http.get(`${this.baseUrl}/message-instance/basket/${basketId}`);
  }

  /**
   * Restituisce la lista dei Panieri, ed è possibile filtrarli per "description"
   * @param basketDesc
   */
  getBasketList(basketDesc?: string) {
    return this.http.get(`${this.baseUrl}/message-instance/basket?notdefault=true&description=${basketDesc}`);
  }

  saveCouponParametersData(data: any) {
    return this.http.post(`${this.baseUrl}/message-instance/layout`, data);
  }

  updateCouponParametersData(data: any, messageInstanceId: number, actionTypeCode: any) {
    return this.http.put(`${this.baseUrl}/message-instance/layout/${messageInstanceId}?actionTypeCode=${actionTypeCode}`, data);
  }

  saveNewBasket_old(messageInstanceId: string, data: any) {
    return this.http.post(`${this.baseUrl}/message-instance/${messageInstanceId}/basket_complete`, data);
  }

  saveMessageComplete(messageInstanceId: string, data: any) {
    return this.http.put(`${this.baseUrl}/message-complete/${messageInstanceId}`, data);
  }

  generateCoupon(data: any) {
    return this.http.post(this.generateCouponUrl, data);
  }

  distributionListCount(data: any) {
    return this.http.post(`${this.baseUrl}/campaign_distribution_list/count`, data);
  }
  deleteAction(actionId: number) {
    return this.http.delete(`${this.baseUrl}/campaign_action/${actionId}`);
  }

  saveTouchpointLayout(actionId: number, layoutId: number, channelId: number, data: any) {
    return this.http.put(`${this.baseUrl}/campaign_action/saveJsonLayout/${actionId}/${layoutId}/${channelId}`, data);
  }

  getWorkflowList() {
    return this.http.get('koncentro-loyalty/params?param_group=ExternalWorkflow');
  }

  saveExternalWorkflowLayout(messageInstanceId: number, externalWorkflow: any) {
    return this.http.put(`${this.baseUrl}/message-instance/saveExternalWorkflowLayout/${messageInstanceId}`, { externalWorkflow });
  }

  saveTouchpointDefaultLayout(messageIstanceId: number, layoutId: number, data: any) {
    return this.http.put(`${this.baseUrl}/message-instance/saveJsonLayout/${messageIstanceId}/${layoutId}`, data);
  }

  viewCampaignAction(campaignId: number, messageInstanceId: number, campaignActionId: number) {
    return this.http.get(`${this.baseUrl}/campaign_action/viewCampaignAction/${campaignId}/${messageInstanceId}/${campaignActionId}`)
  }

  getCouponByCustomerId(customerId: number): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    return this.http.getPaged(`${this.baseUrl}/message-instance/coupon?limit=99999&customer_id=${customerId}`)
  }

  deployAction(message_instance_id: number) {
    return this.http.put(`${this.baseUrl}/deployAction/${message_instance_id}`, {})
  }

  getProductItemByHostCode(productItem?: string) {
    return this.http.get(`/koncentro-common/product-item?product_item=${productItem}`);
  }

  getProductItemBarcodeById(productItemId?: string) {
    return this.http.get(`/koncentro-common/product-item/barcode?product_item_id=${productItemId}`);
  }
  getProductDepartmentByBasket(basketId?: any) {
    return this.http.get(`/koncentro-common/product-department?basket_id=${basketId}`);
  }

  getBasketDetailByBasketId(basketId: any) {
    return this.http.get(`${this.baseUrl}/message-instance/basket-detail?basket_id=${basketId}`);
  }

  createBasketDetail(data) {
    return this.http.post(`${this.baseUrl}/message-instance/basket-detail`, data);
  }

  updateBasketDetail(basketId: any, data?) {
    return this.http.put(`${this.baseUrl}/message-instance/basket-detail/${basketId}`, data);
  }

  removeBasketDetail(basketDetailId: any) {
    return this.http.delete(`${this.baseUrl}/message-instance/basket-detail/${basketDetailId}`);
  }

  createBasket(messageInstanceId: string, data) {
    return this.http.post(`${this.baseUrl}/message-instance/${messageInstanceId}/basket`, data);
  }

  getTableauData() {
    return this.http.get('koncentro-api/tableau/token');
  }

  getCampaignAcmList(messageInstanceId: string) {
    return this.http.get(`${this.baseUrl}/message-channel-acm?message_instance_id=${messageInstanceId}`);
  }

  createAcm(acmData: any) {
    return this.http.post(`${this.baseUrl}/message-channel-acm`, acmData);
  }

  updateAcm(acmData: any, id: number) {
    return this.http.put(`${this.baseUrl}/message-channel-acm/${id}`, acmData);
  }

  deleteAcm(id: number) {
    return this.http.delete(`${this.baseUrl}/message-channel-acm/${id}`);
  }

  getValidityCoupon(paramCode: string) {
    return this.http.get(`koncentro-loyalty/params?param_group=validity_coupon&param_code=${paramCode}`);
  }

  getMessageInstanceRule(messageInstanceId) {
    return this.http.get(`${this.baseUrl}/message-instance/message-instance-rule?message_instance_id=${messageInstanceId}`);
  }

  createMessageInstanceRule(data) {
    return this.http.post(`${this.baseUrl}/message-instance/message-instance-rule`, data);
  }

  updateMessageInstanceRule(id, data) {
    return this.http.put(`${this.baseUrl}/message-instance/message-instance-rule/${id}`, data);
  }

  deleteMessageInstanceRule(id) {
    return this.http.delete(`${this.baseUrl}/message-instance/message-instance-rule/${id}`);
  }

  deleteMessageInstanceRuleAndDetail(id) {
    return this.http.delete(`${this.baseUrl}/message-instance/message-instance-rule/detail/${id}`);
  }

  getMultipleCouponRuleType() {
    return this.http.get(`${this.baseUrl}/message-instance/message-instance-rule-type?code=CV`)
  }




  /*** UTILIZZATI IN CAMPAIGN 3 */

  /**
   * Restituisce la lista dei Tipi di Coupon
   */

  /**
  * Restituisce la lista degli action type
  * @returns ritorna la lista di action type
  */
  getActionTypeList(): Observable<Array<ActionType>> {
    //return this.http.get(this.baseUrl + '/action_type');
    let at1: ActionType = new ActionType();
    at1.shortCode = "C";
    at1.code = "CPN";
    at1.description = "Coupon";
    at1.name = "Coupon";

    let at2: ActionType = new ActionType();
    at2.shortCode = "M";
    at2.code = "MSG";
    at2.description = "Messaggio";
    at2.name = "Messaggio";

    let array = new Array<ActionType>();
    array.push(at2, at1);

    return Observable.of(array);
  }
  /**
   * Restituisce la lista dei tipi coupon
   * @returns ritorna la lista di tipi coupon
   */
  getCouponTypes(): Observable<Array<CouponType>> {
    return this.http.get("/koncentro-promo/campaign/message?assignement_entity=coupon");
  }
  getMessageTypes(): Observable<Array<MessageType>> {

    return this.http.get("/koncentro-promo/campaign/message?assignement_entity=messages");
  }
  getAdvantageTypes(): Observable<Array<AdvantageType>> {

    return this.http.get('/koncentro-promo/discount-type');
  }
  /**
 * Restituisce un azione di una campagna, tramite il suo id
 * @param messageInstanceType tipo di azione CPN coupon o MSG message
 * @param modeType modalità create o edit
 * @param campaignId id campagna
 */
  getJsonFormSchema(messageInstanceType: string, modeType: string, assigned_to_id: string) {

    let miUrl = this.actionTypes.COUPON.assignmentEntity;

    //rimosso perchè superfluo
    //messageInstanceType "C" (coupon), "M" message
    /*   if(messageInstanceType == this.actionTypes.COUPON.shortCode){
        miUrl = this.actionTypes.COUPON.assignmentEntity;
      }
      if(messageInstanceType == this.actionTypes.MESSAGE.shortCode){
        miUrl = this.actionTypes.MESSAGE.assignmentEntity;
      } */

    return this.http.get(this.baseUrl + "/template_assignement/list?assignement_entity=" + miUrl + "&assignement_type=" + modeType + "&assigned_to_id=" + assigned_to_id);
  }
  getJsonFormSchemaMessage(messageInstanceType: string, modeType: string, assigned_to_id: string) {

    let miUrl;

    miUrl = this.actionTypes.MESSAGE.assignmentEntity;

    return this.http.get(this.baseUrl + "/template_assignement/list?assignement_entity=" + miUrl + "&assignement_type=" + modeType + "&assigned_to_id=" + assigned_to_id);
  }

  getPreparedFormSchemas(resSchemaBE) {




    if (resSchemaBE) {

      let mainForm = resSchemaBE.form_def;
      let jsonSchema = new JsonSchema();
      jsonSchema.title = mainForm["title"];
      jsonSchema.description = mainForm["description"];
      jsonSchema.type = mainForm["type"];


      if (resSchemaBE.assignement_entity == "message") {
        //inizializzazione schema form dei vari tab
        jsonSchema.properties.infoBase = this.getPreparedFormSchema(jsonSchema, mainForm, "infoBase", this.infoBaseFieldsName);
        jsonSchema.properties.pianificazione = this.getPreparedFormSchema(jsonSchema, mainForm, "pianificazione", this.pianificazioneFieldsName);
        jsonSchema.properties.tipoAzioni = this.getPreparedFormSchema(jsonSchema, mainForm, "tipoAzioni", this.tipoAzioniFieldsName);
        //TODO temp
        jsonSchema.properties.emissione = this.getPreparedFormSchema(jsonSchema, mainForm, "emissione", this.emissioneFieldsNameTemp);
        jsonSchema.properties.customerTarget = this.getPreparedFormSchema(jsonSchema, mainForm, "customerTarget", this.customerTargetFieldsName);
        jsonSchema.properties.targetArticoli = this.getPreparedFormSchema(jsonSchema, mainForm, "targetArticoli", this.targetArticoliFieldsName);
        jsonSchema.properties.touchpoint = this.getPreparedFormSchema(jsonSchema, mainForm, "touchpoint", this.touchpointFieldsName);
      } else {
        //inizializzazione schema form dei vari tab
        jsonSchema.properties.infoBase = this.getPreparedFormSchema(jsonSchema, mainForm, "infoBase", this.infoBaseFieldsName);
        jsonSchema.properties.pianificazione = this.getPreparedFormSchema(jsonSchema, mainForm, "pianificazione", this.pianificazioneFieldsName);
        jsonSchema.properties.tipoAzioni = this.getPreparedFormSchema(jsonSchema, mainForm, "tipoAzioni", this.tipoAzioniFieldsName);
        jsonSchema.properties.emissione = this.getPreparedFormSchema(jsonSchema, mainForm, "emissione", this.emissioneFieldsName);
        jsonSchema.properties.fruizione = this.getPreparedFormSchema(jsonSchema, mainForm, "fruizione", this.fruizioneFieldsName);
        jsonSchema.properties.customerTarget = this.getPreparedFormSchema(jsonSchema, mainForm, "customerTarget", this.customerTargetFieldsName);
        jsonSchema.properties.targetArticoli = this.getPreparedFormSchema(jsonSchema, mainForm, "targetArticoli", this.targetArticoliFieldsName);
        jsonSchema.properties.touchpoint = this.getPreparedFormSchema(jsonSchema, mainForm, "touchpoint", this.touchpointFieldsName);
      }

      return jsonSchema;
    }

  }


  getPreparedFormSchema(jsonSchema: JsonSchema, resSchemaBE: any, nameFieldForm: string, fieldsName: any): JsonSchemaFormPropertiesForm {
    const level1 = resSchemaBE.properties[this.formNames[nameFieldForm]];
    jsonSchema.properties[nameFieldForm].formName = this.formNames[nameFieldForm]; // conosciuto a priori
    jsonSchema.properties[nameFieldForm].id = level1.id;
    jsonSchema.properties[nameFieldForm].description = level1.description;
    for (let name in fieldsName) {
      //const fieldProperties = formFields[this.pianificazioneFieldsName[name]];
      const fieldProperties = resSchemaBE.properties[this.formNames[nameFieldForm]].properties[fieldsName[name]];
      const arrayRequired = level1.required ? level1.required : [];
      const arrayDisabled = level1.disabled ? level1.disabled : [];
      const arrayHidden = level1.hidden ? level1.hidden : [];

      if (fieldProperties) {
        jsonSchema.properties[nameFieldForm].form[name] = {};
        jsonSchema.properties[nameFieldForm].form[name]["id"] = fieldProperties.id;
        jsonSchema.properties[nameFieldForm].form[name]["description"] = fieldProperties.description;
        jsonSchema.properties[nameFieldForm].form[name]["fieldName"] = name;
        jsonSchema.properties[nameFieldForm].form[name]["step"] = fieldProperties.step ? +fieldProperties.step : null;
        jsonSchema.properties[nameFieldForm].form[name]["maxLength"] = fieldProperties.maxLength ? +fieldProperties.maxLength : null;
        jsonSchema.properties[nameFieldForm].form[name]["minLength"] = fieldProperties.minLength ? +fieldProperties.minLength : null;
        jsonSchema.properties[nameFieldForm].form[name]["minValue"] = fieldProperties.minValue ? Number.parseFloat(fieldProperties.minValue) : null;
        jsonSchema.properties[nameFieldForm].form[name]["maxValue"] = fieldProperties.maxValue ? Number.parseFloat(fieldProperties.maxValue) : null;
        jsonSchema.properties[nameFieldForm].form[name]["default"] = fieldProperties.default ? fieldProperties.default : null;
        jsonSchema.properties[nameFieldForm].form[name]["pattern"] = fieldProperties.pattern ? fieldProperties.pattern : null;
        jsonSchema.properties[nameFieldForm].form[name]["type"] = fieldProperties.type ? fieldProperties.type : null;
        jsonSchema.properties[nameFieldForm].form[name]["required"] = arrayRequired.includes(fieldsName[name]);
        jsonSchema.properties[nameFieldForm].form[name]["disabled"] = arrayDisabled.includes(fieldsName[name]);
        jsonSchema.properties[nameFieldForm].form[name]["radioOptions"] = fieldProperties.radioOptions;
        jsonSchema.properties[nameFieldForm].form[name]["options"] = fieldProperties.options ? fieldProperties.options : null;

        jsonSchema.properties[nameFieldForm].form[name]["visible"] = arrayHidden.includes(fieldsName[name]) ? false : true;

        if (fieldProperties.label) {
          jsonSchema.properties[nameFieldForm].form[name]["label"] = {};
          jsonSchema.properties[nameFieldForm].form[name].label["it"] = fieldProperties.label.it ? fieldProperties.label.it : null;
          jsonSchema.properties[nameFieldForm].form[name].label["en"] = fieldProperties.label.it ? fieldProperties.label.en : null;
        }
      }
    }

    return jsonSchema.properties[nameFieldForm];
  }
  getAllCampaignPhases(actionTypeCode: string): Array<PhaseToolbarModel> {

    let res = null;

    if (actionTypeCode == this.actionTypes.COUPON.code) {
      let f1: PhaseToolbarModel = new PhaseToolbarModel();
      f1.index = 0;
      f1.code = "f1";
      f1.description = "Info Base";

      let f2: PhaseToolbarModel = new PhaseToolbarModel();
      f2.index = 1;
      f2.code = "f2";
      f2.description = "Pianificazione";

      let f3: PhaseToolbarModel = new PhaseToolbarModel();
      f3.index = 2;
      f3.code = "f3";
      f3.description = "Tipi di azione";

      let f4: PhaseToolbarModel = new PhaseToolbarModel();
      f4.index = 3;
      f4.code = "f4";
      f4.description = "Condizioni di emissione";

      let f5: PhaseToolbarModel = new PhaseToolbarModel();
      f5.index = 4;
      f5.code = "f5";
      f5.description = "Condizioni di fruizione";

      let f6: PhaseToolbarModel = new PhaseToolbarModel();
      f6.index = 5;
      f6.code = "f6";
      f6.description = "Customer Target";

      let f7: PhaseToolbarModel = new PhaseToolbarModel();
      f7.index = 6;
      f7.code = "f7";
      f7.description = "Target Articoli";

      let f8: PhaseToolbarModel = new PhaseToolbarModel();
      f8.index = 7;
      f8.code = "f8";
      f8.description = "Touchpoint";

      let f9: PhaseToolbarModel = new PhaseToolbarModel();
      f9.index = 8;
      f9.code = "f9";
      f9.description = "Validazioni";

      res = [f1, f2, f3, f4, f5, f6, f7, f8, f9];
    }
    else if (actionTypeCode == this.actionTypes.MESSAGE.code) {
      let f1: PhaseToolbarModel = new PhaseToolbarModel();
      f1.index = 0;
      f1.code = "f1";
      f1.description = "Info Base";

      let f2: PhaseToolbarModel = new PhaseToolbarModel();
      f2.index = 1;
      f2.code = "f2";
      f2.description = "Pianificazione";

      let f3: PhaseToolbarModel = new PhaseToolbarModel();
      f3.index = 2;
      f3.code = "f3";
      f3.description = "Tipi di azione";

      let f4: PhaseToolbarModel = new PhaseToolbarModel();
      f4.index = 3;
      f4.code = "f4";
      f4.description = "Condizioni di emissione";

      let f5: PhaseToolbarModel = new PhaseToolbarModel();
      f5.index = 4;
      f5.code = "f5";
      f5.description = "Customer Target";

      let f6: PhaseToolbarModel = new PhaseToolbarModel();
      f6.index = 5;
      f6.code = "f6";
      f6.description = "Target Articoli";

      let f7: PhaseToolbarModel = new PhaseToolbarModel();
      f7.index = 6;
      f7.code = "f7";
      f7.description = "Touchpoint";

      let f8: PhaseToolbarModel = new PhaseToolbarModel();
      f8.index = 7;
      f8.code = "f8";
      f8.description = "Validazioni";

      res = [f1, f2, f3, f4, f5, f6, f7, f8];
    }
    else {
      res = null;
    }
    return res;


  }

  /**
   * Restituisce la Campagna con id = campaignId
   * @param campaignId
   */
  getCampaign(campaignId: number) {
    return this.http.get(this.baseUrl + `?id=${campaignId}`);
  }

  /**
   * Salva o modifica l'oggettone finale dell'Azione
   * @param messageInstanceObject
   */
  saveOrEditMessageInstanceComplete(messageInstanceObject: MessageInstanceObject): Observable<number> {
    return this.http.post(`${this.baseUrl}/message-instance/messageInstanceSingleObject`, messageInstanceObject).map(res => {
      return res;
    });
  }
  getMessageInstanceComplete(messageInstanceId: number): Observable<CampaignSingleObjectResponse> {
    return this.http.get(`${this.baseUrl}/message-instance/getCampaignSingleObject?message_instance_id=${messageInstanceId}`);

  }
  getProductItemBarcodeList(): Observable<Array<ProductItemComplete>> {
    return this.http.get(`/koncentro-common/product-item/product-item-barcode`);
  }

  private actionURL = "/koncentro-promo/campaign/message-instance";


  getDateStringDBFromDate(date: Date): string | null {
    let res = null;
    if (date) {
      let anno: number = date.getFullYear();
      let mese: number = date.getMonth() + 1; // Month è 0-based, quindi aggiungiamo 1
      let giorno: number = date.getDate();

      // Aggiungi zeri iniziali se il mese o il giorno sono inferiori a 10
      let meseStringa: string = mese < 10 ? '0' + mese : '' + mese;
      let giornoStringa: string = giorno < 10 ? '0' + giorno : '' + giorno;

      res = anno + "-" + meseStringa + "-" + giornoStringa;
    }
    return res;
  }
  getDateFromDateStringDB(dateStringDB: string): Date | null {
    let res = null;
    if (dateStringDB && dateStringDB.length == 10) {

      // Dividi la stringa in parti separate
      const dateParts: string[] = dateStringDB.split("-");
      const year: number = parseInt(dateParts[0]);
      const month: number = parseInt(dateParts[1]) - 1; // I mesi in JavaScript vanno da 0 a 11
      const day: number = parseInt(dateParts[2]);

      // Crea un oggetto Date
      res = new Date(year, month, day);
    }
    return res;
  }
  getInitialBreadCrumbs(campaignName: string) {

    let arrayBreadcrumbs: Array<BreadCrumbModel> = [];
    let bc1 = new BreadCrumbModel();
    bc1.code = "bc1";
    bc1.description = "Campagne";
    bc1.routerLink = "/campaign-list-3"

    let bc2 = new BreadCrumbModel();
    bc2.code = "bc2";
    bc2.description = campaignName;

    let bc3 = new BreadCrumbModel();
    bc3.code = "bc3";
    bc3.description = "Creazione Coupon";

    arrayBreadcrumbs.push(bc1, bc2, bc3);
    return arrayBreadcrumbs;
  }
  getInitialBreadCrumbs_Message(campaignName: string) {

    let arrayBreadcrumbs: Array<BreadCrumbModel> = [];
    let bc1 = new BreadCrumbModel();
    bc1.code = "bc1";
    bc1.description = "Campagna";
    bc1.routerLink = "/campaign-list-3"

    let bc2 = new BreadCrumbModel();
    bc2.code = "bc2";
    bc2.description = campaignName;

    let bc3 = new BreadCrumbModel();
    bc3.code = "bc3";
    bc3.description = "Creazione Messaggio";

    arrayBreadcrumbs.push(bc1, bc2, bc3);
    return arrayBreadcrumbs;
  }
  getMessageInstanceRuleTypes(): Observable<Array<MessageInstanceRuleTypes>> {
    return this.http.get(`${this.baseUrl}/message-instance/message-instance-rule-type`)
  }
  getMessageInstanceObjectTypes(): Observable<Array<MessageInstanceObjectTypes>> {
    return this.http.get(`${this.baseUrl}/message-instance/message-instance-object-type`)
  }
  getDistributionListCluster(): Observable<Array<DistributionListCluster>> {
    return this.http.get(`${this.baseUrl}/distribution_list/distribution-list-cluster?limit=99999`);
  }
  getDistributionListExpiredOrFutureCluster(distributionListId: number, dateStart: string, dateEnd: string): Observable<number> {
    return this.http.get(`${this.baseUrl}/distribution_list/getDistributionListExpiredOrFutureCluster?distribution_list_id=${distributionListId}&date_start=${dateStart}&date_end=${dateEnd}`);
  }
  getDistributionListDetails(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number): Observable<Array<DistributionListDetails>> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/distribution_list/details?distribution_list_id=' + this.distributionListId + "&" + params.toString());
  }
  getClusterHeadNewList(): Observable<Array<ClusterHeadNewList>> {
    return this.http.get(`${this.loyaltyUrl}/cluster/getClusterHeadAllList?sort=id&sort_dir=-1&offset=0&limit=99999`);
  }
  /*** utilizzati in cascata da customer target ***/
  createDistributionList(name: string): Observable<any> {
    let body = {
      name: name
    }
    return this.http.post(`${this.baseUrl}/distribution_list`, body);
  }
  addClusterHeadList(idDistributionList: number, arrayClusterHeads: Array<number>): Observable<boolean> {
    let body = {
      distribution_list_id: idDistributionList,
      cluster_head_id_array: arrayClusterHeads
    }
    return this.http.post(`${this.baseUrl}/distribution_list_cluster_head/cluster-head`, body);
  }
  //KS-7860
  getBasketProductItems(limit: number = 99999): Observable<Array<BasketProductItem>> {
    return this.http.get(`${this.campaignUrl}/basket/basket-product-item?limit=${limit}`);
  }
  getProductDepartmentList(): Observable<Array<ProductDepartment>> {
    return this.http.get(`/koncentro-common/product-department`);
  }
  getAllProductCategories(): Observable<Array<ProductCategory>> {
    return this.http.get(`/koncentro-common/product-category`);
  }
  getAllProductCategoriesNoLimit(): Observable<Array<ProductCategory>> {
    return this.http.get(`/koncentro-common/product-category?limit=99999`);
  }
  getTouchpoints(type: string, actionType: string): Observable<Array<Touchpoint>> {
    //type = E oppure F (emissione o fruizione)
    //actionType = C oppure M (coupon o messaggio)
    return this.http.get(`${this.campaignUrl}/touch-point?flg_coupon_scope=${type}&flg_coupon_action=${actionType}`);
  }
  getAllCampaigns(): Observable<Array<Campaign3Campaign>> {
    return this.http.get(`${this.baseUrl}`);
  }

  getAllCampaignsNoLimit(): Observable<Array<Campaign3Campaign>> {
    return this.http.get(`${this.baseUrl}?limit=9999`);
  }

  /**
 * Restituisce la lista dei negozi associabili alla Campagna, filtrandoli a seconda dei parametri inviati.
 * Se nel parametro "codici" di "filters" sono presenti store_code, restituisce i negozi già associati alla Campagna
 * @param filters
 */
  //KS-7526 : aggiunta parametro di storeDateBetween
  /*   getStoresFromCampaigns(filters: object): Observable<Array<Campaign3Store>> {
      return this.http.post('/koncentro-common/store/stores_from_campaigns?limit=999999', filters);
    } */

  getStoresFromCampaigns(filters: any): Observable<Array<Campaign3Store>> {
    const payload = {
      ...filters,
      storeDateEnd: true
    };
    return this.http.post('/koncentro-common/store/v2/stores_from_campaigns?limit=999999', payload);
  }

  getMessageInstanceFromCampaign(idCampaign: number): Observable<Array<Campaign3MessageInstance>> {
    return this.http.get(`${this.baseUrl}/message-instance?campaign_id=${idCampaign}`);
  }
  /**
 * Restituisce i touchpoint di emissione di una action, con i relativi form schema di layout
 */
  getEmissionTouchpointsAndLayouts(actionId: number) {
    return this.http.get(`${this.baseUrl}/layout_config/${actionId}`);
  }
  getEmissionTouchpointAndLayoutsDefault(messageInstanceId: number) {
    return this.http.get(`${this.baseUrl}/layout_config/default/${messageInstanceId}`);
  }
  getAreaGeoForCouponing(): Observable<Array<AreaGeo>> {
    return this.http.get(`${this.commonUrl}/store/getAreaGeoForCouponing`);
  }
  getGroupsForCouponing(): Observable<Array<Group>> {
    return this.http.get(`${this.commonUrl}/store-group`);
  }
  getSalesNetworkForCouponing(): Observable<Array<Insegna>> {
    return this.http.get(`${this.commonUrl}/store/getInsegna`);
  }
  duplicateCampaignAction(data: Campaign3DuplicateAction) {
    return this.http.post(`${this.baseUrl}/message-instance/duplicateAction`, data);
  }
  getTouchPointListForCouponing(couponScope: string, couponActionType: string): Observable<Array<Touchpoint>> {
    return this.http.get(`${this.campaignUrl}/touch-point/getTouchPointListForCouponing?flg_coupon_scope=${couponScope}&flg_coupon_action=${couponActionType}`);
  }
  getTouchPointListForCouponing_new(couponScope: string, couponActionType: string, messageIndtnceId: number): Observable<Array<Touchpoint>> {
    return this.http.get(`${this.campaignUrl}/touch-point/getTouchPointListForCouponing?flg_coupon_scope=${couponScope}&flg_coupon_action=${couponActionType}&message_instance_id=${messageIndtnceId}`);
  }
  getStatusNumberFromCode(code: string, statusMapping: Campaign3StatusMapping): number {
    let res = null;
    for (let key in statusMapping) {
      if (statusMapping[key].code == code) {
        res = statusMapping[key].number;
        return res;
      }
    }
    return res;
  }
  getStatusCodeFromNumber(num: number, statusMapping: Campaign3StatusMapping): string {

    let res = null;
    for (let key in statusMapping) {
      if (statusMapping[key].number == num) {
        res = statusMapping[key].code;
        return res;
      }
    }
    return res;
  }


  saveNewBasket(payload: any) {
    return this.http.post(`${this.campaignUrl}/basket/createBasket`, payload);
  }



  saveNewBasket_old2(name: string): Observable<number> {

    return Observable.of(4);
    //return this.http.post(`${this.campaignUrl}/basket`, data);
  }
  saveNewBaskerDetails(basketId: number, arrayProductId: Array<number>) {

    return Observable.of(true);
  }
  preview(campaignId: number, messageIstanceId: number, publishable: boolean) {

    let body = {
      message_instance_id: messageIstanceId,
      campaign_id: campaignId,
      publishable: publishable
    }

    return this.http.post(`${this.baseUrl}/message-instance/previewMessageInstance`, body);
  }
  publish(campaignId: number, messageInstanceId: number, publishable: boolean) {

    let body = {
      campaign_id: campaignId,
      message_instance_id: messageInstanceId,
      publishable: publishable
    }

    return this.http.post(`${this.baseUrl}/message-instance/publishMessageInstance`, body);
  }
  /*   undoPublish_OLD(campaignId: number, messageInstanceId: number){

      let body = {
        campaign_id: campaignId,
        message_instance_id: messageInstanceId
      }

      return this.http.post(`${this.baseUrl}/message-instance/undoPublishMessageInstance`, body);
    } */
  undoPublish(campaignId: number, messageInstanceId: number, publishable: boolean) {

    let body = {
      campaign_id: campaignId,
      message_instance_id: messageInstanceId,
      publishable: publishable
    }

    return this.http.post(`${this.baseUrl}/message-instance/undoPublishMessageInstance`, body);
  }
  /*
  cancelPublication(data: any) {
    return this.http.post(`${this.baseUrl}/message-instance/publishMessageInstance`, data);
  }
  */

  /**
   * Restituisce i negozi associati alla action
   */
  getTouchpointStores(messageInstanceId: number, touchpointId: string, scope: string) {
    //scope --> "E" per emission o "F" per fruition
    return this.http.get(`${this.baseUrl}/store-message-ochannel?message_instance_id=${messageInstanceId}&ochannel_id=${touchpointId}&store_type=${scope}`);
  }
  saveTouchpointStores(messageInstanceId: number, touchpointId: number, scope: string, storeId: number = null, storeGroup: number = null) {
    let body = {
      message_instance_id: messageInstanceId,
      ochannel_id: touchpointId,
      store_type: scope //E oppure F
    }

    if (storeId > 0) {
      body["store_id"] = storeId
    }

    if (storeGroup > 0) {
      body["store_group_id"] = storeGroup;
    }

    return this.http.post(`${this.baseUrl}/store-message-ochannel`, body);
  }
  deteleTouchpointStores(store_message_ochannel_id) {
    return this.http.delete(`${this.baseUrl}/store-message-ochannel/${store_message_ochannel_id}`);
  }
  getAllActionStatus(): Observable<Campaign3ActionStatus> {
    return this.http.get(`${this.baseUrl}/message-instance-action-status`);
  }
  getAllCertificationTouchpoint(message_instance_id: number): Observable<CertificationTouchpointList> {
    return this.http.get(`${this.baseUrl}/message-instance/certified?message_instance_id=${message_instance_id}`);
  }
  getProductItemCompleteOnlyBarcode(offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number): Observable<{ data: Array<ProductItemComplete> }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`/koncentro-common/product-item/complete` + "?" + params.toString() + "&only_barcode=true");
  }
  //test volevo creare una funzione che comprendesse il passaggio della messageinstanceId ma dovrei costruire una funzione apposta e cambiare app-form-fields
  getProductItemCompleteOnlyBarcodeAndId(message_instance_id: number): Observable<{ data: Array<ProductItemComplete> }> {

    return this.http.getPaged(`/koncentro-common/product-item/complete` + "?" + "message_instance_id=" + message_instance_id.toString() + "&only_barcode=true");
  }
  //nuova chiamata per il product attivatore che sostituisce la complete
  getProductActivator(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number): Observable<{ data: Array<ProductItemComplete> }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`/koncentro-common/product-item/completeActivator` + "?" + params.toString());
  }

  getProductItemComplete(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number): Observable<{ data: Array<ProductItemComplete> }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`/koncentro-common/product-item/complete` + "?" + params.toString());
  }

  // --- BASKET ---
  getBasketsByIds(ids: number[]): Observable<any> {
    if (!ids || ids.length === 0) {
      return of([]);
    }

    const idsParam = ids.join(',');

    return this.http.getPaged(
      `/koncentro-promo/basket/basket-product-item?ids=${idsParam}&limit=99999`
    );
  }

  // --- CATEGORY ---
  getCategoriesByIds(ids: number[]): Observable<any> {
    if (!ids || ids.length === 0) {
      return of([]);
    }
    const idsParam = ids.join(',');
    return this.http.getPaged(`/koncentro-common/product-category?ids=${idsParam}`);
  }

  // --- PRODUCT ---
  getProductsByIds(ids: number[]): Observable<any> {
    if (!ids || ids.length === 0) {
      return of([]);
    }
    const idsParam = ids.join(',');
    return this.http.getPaged(`/koncentro-common/product-item/complete?ids=${idsParam}`);
  }

  // --- DEPARTMENT ---
  getDepartmentsByIds(ids: number[]): Observable<any> {
    if (!ids || ids.length === 0) {
      return of([]);
    }
    const idsParam = ids.join(',');
    return this.http.getPaged(`/koncentro-common/product-department?ids=${idsParam}`);
  }

  getCouponParametersDefaultData(messageId: number) {
    return this.http.get(`${this.baseUrl}/message/${messageId}`);
  }
  anteprimaCoupon(data) {
    return this.http.post(`koncentro-proxy/proxy/ibc/anteprimaCoupon/v1`, data);
  }
  anteprimaCoupon_V2(ochannel_id: number, message_instance_id: number) {

    let body = {
      ochannel_id: ochannel_id,
      message_instance_id: message_instance_id
    }

    return this.http.post(`${this.baseUrl}/message-instance/getPreviewCoupon`, body);
  }
  checkBarcodeAvailability(data: any): Observable<any> {
    let url = `${this.baseUrl}/message-instance/barcodeAvailability`;

    return this.http.post(url, data, true).pipe(
      map((res: any) => {
        return true;
      }),
      catchError(error => {
        console.error('Errore:', error);
        return Observable.of(false);
      })
    );
  }
  checkBarcodeAvailability_OLD(campaignId: any, barcode?: string, messageInstanceId?: any, data?): Observable<any> {
    let url = `${this.baseUrl}/message-instance/barcodeAvailability/${campaignId}?barcode=${barcode}`;
    if (messageInstanceId !== undefined && messageInstanceId !== null) {
      url += `&message_instance_id=${messageInstanceId}`;
    }

    return this.http.post(url, data, true).pipe(
      map((res: any) => {
        return true;
      }),
      catchError(error => {
        console.error('Errore:', error);
        return Observable.of(false);
      })
    );
  }
  //dovuto usare il map per adattare i dati
  //Ricerca le azioni preferite
  getPreferredCoupons(): Observable<Array<PreferredCoupon>> {
    const params = new URLSearchParams();
    params.set('favourites', 'true');
    return this.http.getPaged(this.actionURL + '?' + params.toString())
      .pipe(map(res => res.data));
  }


  checkIfActionIsFavourite(): Observable<any> {
    const payload = { favourite: true }; // Poiché è sempre true, non c'è bisogno di passarlo come parametro
    return this.http.post(this.favouriteActionUrl, payload);
  }


  favouriteActionUrl = "/koncentro-promo/campaign/message-instance/favouritesMessageInstance"
  //Salva le azioni preferite
  saveActionIntoFavourites(action: MessageInstanceObject): Observable<any> {
    const payload = {
      message_instance_id: action.id,
      operation: "ADD"
    };
    return this.http.post(this.favouriteActionUrl, payload);
  }

  //elimina le azioni preferite
  deleteActionFromFavourites(action: MessageInstanceObject): Observable<any> {
    const payload = {
      message_instance_id: action.id,
      operation: "DEL"
    };
    return this.http.post(this.favouriteActionUrl, payload);
  }

  //Salva le azioni preferite
  calculateFruitionDate(calculateFruitionDate: CalculateFruitionDateRequest): Observable<CalculateFruitionDateResponse> {
    return this.http.post(`${this.baseUrl}/message-instance/calculateFruitionDate`, calculateFruitionDate);
  }
  /**
     * Crea un nuovo Gruppo di Negozi
     * @param groupData
     */
  createGroup(groupData) {
    return this.http.post('/koncentro-common/store-group', groupData);
  }

  /**
   * Aggiunge gli stores selezionati al gruppo con groupid
   * @param groupId
   * @param stores
   */
  setStoresInGroup(groupId, stores) {
    return this.http.post(`/koncentro-common/store-group/${groupId}/store`, stores);
  }



  getDeployActionData(id) {
    return this.http.get(`koncentro-promo/campaign/getDeployActionData/${id}?onlyRefused=true`);
  }




  resetDeploymentStateToComplete(id, status) {

    const payload = {
      id: id,
      status: status
    };

    return this.http.put(`koncentro-promo/campaign/message-instance/changeActionStatus`, payload);
  }


  getMessageInstanceRuleObjectTypeList(ochannelId: number) {
    return this.http.get(
      `${this.baseUrl}/message-instance/message-instance-rule-object-type/list`,
      { ochannel_id: ochannelId }
    ) as Observable<MessageInstanceRuleObjectTypeResponse>;
  }




}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/services/campaign3.service.ts